import { client as apolloClient } from 'graphql/client';

let accessToken = '';

const getAccessToken = (): string => accessToken;

const setAccessToken = (newToken: string): void => {
    accessToken = newToken;
};

const login = (token: string, refreshExpiresIn: number): void => {
    localStorage.setItem('refreshExpiresIn', refreshExpiresIn.toString());
    setAccessToken(token);
};

const logout = (): void => {
    localStorage.removeItem('refreshExpiresIn');
    setAccessToken('');
    apolloClient.cache.reset();
};

const isLoggedIn = (): boolean => !!accessToken;

interface IUseAuth {
    getAccessToken(): string;
    setAccessToken(newToken: string): void;
    login(token: string, refreshExpiresIn: number): void;
    logout(): void;
    isLoggedIn(): boolean;
}

export const useAuth = (): IUseAuth => ({
    getAccessToken,
    setAccessToken,
    login,
    logout,
    isLoggedIn,
});
